import { render } from "./EmailsTable.vue?vue&type=template&id=9084e996"
import script from "./EmailsTable.vue?vue&type=script&lang=js"
export * from "./EmailsTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__